"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastWidget = exports.ToastType = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var ToastBase_1 = require("./ToastBase");
Object.defineProperty(exports, "ToastType", { enumerable: true, get: function () { return ToastBase_1.ToastType; } });
var Toaster_1 = require("./Toaster");
var ToastWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ToastWidget, _super);
    function ToastWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /*
         * below is the shim to the original declarative API, which utilizes lifecycle methods to invoke the imperative API
         * in lieu of declarative rendering
         */
        _this.toastId = undefined;
        /**
         * This method gets called when a declaratively instantiated Toast gets dismissed.
         * It prevents ToastWidget.dismiss() from being called (a 2nd time) in `componentWillUnmount` if the ToastWidget has already dismissed.
         */
        _this.declarativeCleanup = function () {
            var _a, _b;
            _this.toastId = undefined;
            (_b = (_a = _this.props).onCloseRequest) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        return _this;
    }
    /**
     * This must be called in the application initializer before any of the other imperative APIs may be called.
     */
    ToastWidget.initToaster = function (toasterStyle, callback) {
        if (!ToastWidget.toasterRef.current) {
            ToastWidget.toasterDiv = document.createElement('div');
            ToastWidget.toasterDiv.classList.add('tab-shared-widget-toaster');
            document.body.appendChild(ToastWidget.toasterDiv);
            ReactDOM.render(React.createElement(Toaster_1.Toaster, { ref: ToastWidget.toasterRef, style: toasterStyle }), ToastWidget.toasterDiv, callback);
        }
        else {
            callback === null || callback === void 0 ? void 0 : callback();
        }
    };
    /**
     * This will update the styles applied to the `Toaster` element
     */
    ToastWidget.updateToasterStyle = function (toasterStyle) {
        if (ToastWidget.toasterRef.current && ToastWidget.toasterDiv) {
            ReactDOM.render(React.createElement(Toaster_1.Toaster, { ref: ToastWidget.toasterRef, style: toasterStyle }), ToastWidget.toasterDiv);
        }
    };
    /**
     * Shows a new Toast for the specified props.
     * Most use cases will want to use this imperative API, rather than a declarative `<ToastWidget>` in a render method.
     * @returns an id which may optionally be retained for later use with the `ToastWidget.dismiss` or `ToastWidget.update` methods
     */
    ToastWidget.show = function (props) {
        return ToastWidget.toasterRef.current.show(props);
    };
    /**
     * Updates an existing Toast with new props.
     * @param toastId the id previously returned by the `ToastWidget.show` method
     * @param props the updated `ToastProps` to replace in the Toast
     */
    ToastWidget.update = function (toastId, props) {
        ToastWidget.toasterRef.current.update(toastId, props);
    };
    /**
     * Immediately dismisses a currently-shown Toast.
     * @param toastId the id previously returned by the `ToastWidget.show` method
     */
    ToastWidget.dismiss = function (toastId) {
        ToastWidget.toasterRef.current.dismiss(toastId);
    };
    ToastWidget.prototype.componentDidMount = function () {
        var _this = this;
        var addToast = function () { return _this.toastId = ToastWidget.show(tslib_1.__assign(tslib_1.__assign({}, _this.props), { onCloseRequest: _this.declarativeCleanup })); };
        if (!ToastWidget.toasterRef.current) {
            ToastWidget.initToaster({}, addToast);
        }
        else {
            addToast();
        }
    };
    ToastWidget.prototype.componentDidUpdate = function () {
        ToastWidget.update(this.toastId, this.props);
    };
    ToastWidget.prototype.componentWillUnmount = function () {
        if (!!this.toastId) {
            ToastWidget.dismiss(this.toastId);
            this.toastId = undefined;
        }
    };
    ToastWidget.prototype.render = function () { return null; };
    ToastWidget.toasterRef = React.createRef();
    return ToastWidget;
}(React.PureComponent));
exports.ToastWidget = ToastWidget;
//# sourceMappingURL=ToastWidget.js.map